module.exports = "<div class=\"table-edit-container\">\n    <div class=\"column-entry\" *ngFor=\"let column of tableColumns\">\n        <mat-checkbox [(ngModel)]=\"column.enabled\">{{column.title}}</mat-checkbox>\n    </div>\n\n    <button class=\"btn action-button\" (click)=\"close()\">Close</button>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/dialogs/solutions-edit-table/solutions-edit-table.component.html
// module id = ../../../../../src/app/dialogs/solutions-edit-table/solutions-edit-table.component.html
// module chunks = main